import React, { useEffect, useState } from "react";
import { VscDebugStart } from "react-icons/vsc";
import { toast } from "react-toastify";
import "./roomthankyou.css";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate, formatDateByLocaleShort, getCurrency } from "../../../helper/Formatter";
import moment from "moment";
import { createCheckoutBillSessionService } from "../../../API/payment";
import { countDaysBetweenDates, isCheckInWithinDays } from "../../commonFun";

export default function RoomThankYouPage({branchDataRes}) {
  // console.log('branchDataRes::: ', branchDataRes);
  const location = useLocation();
  // console.log('location::: ', location);
  const lastPrice = location.state?.lastPrice
  const loginUserId = localStorage.getItem("LoginUserId");
  const loginUserType = localStorage.getItem("LoginUserType")
  const navigate = useNavigate();
  const compName = localStorage.getItem("branchname");
  const lastPrices = JSON.parse(localStorage.getItem("lastPrice"))
  const primaryemail = JSON.parse(localStorage.getItem("userData"))?.property?.primaryemail
  const advDays =   Number(branchDataRes?.appointmentsetting?.booking_advance_days || 0);
  const insideDaysLimit = isCheckInWithinDays(advDays)

  // console.log('primaryemail::: ', primaryemail);



  const [allPayloadData] = useState(
    location?.state?.BookedRoomInfo || JSON.parse(localStorage.getItem("allPayloadData"))
  );
  const rawData = JSON.parse(localStorage.getItem("data")) || JSON.parse(localStorage.getItem("prospectdata"));
  // console.log('rawData::: ', rawData);
  const billDetails = location?.state?.billDetails || JSON.parse(localStorage.getItem("billDetails"));
  // console.log('billDetails::: ', billDetails);
  const appointmentData = location?.state?.appointmentData || JSON.parse(localStorage.getItem("appointmentData"));
  // console.log('appointmentData::: ', appointmentData?.appointments?.[0]?._id);

  // console.log('allPayloadData::: ', allPayloadData);

  useEffect(() => {
    if(!localStorage.getItem("LoginUserId")){
      navigate(`/${compName}`);
    }
}, []);


  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      toast.warning("🚫 You can't go back to the previous page.", {
        autoClose: 1000,
      });
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const handleDashboardRedirect = () => {
    sessionStorage.removeItem("bookingData");
    sessionStorage.removeItem("billDetails");
    sessionStorage.removeItem("data");
    navigate(`/${compName}/mydashbord`);

  };



  async function handleGotoPayment() {
    let postData = {
      // charges: Math.round(Number(billDetails?.grandtotal) * 100),
      charges: (insideDaysLimit?.isWithinRange === true) ?
      Math.round(Number(lastPrice?.total || lastPrices?.total) * 100)
      : Math.round(Number(lastPrice?.advanceAmount || lastPrices?.advanceAmount) * 100),

      memberid: loginUserId,
      billid: appointmentData?.billid,
      paymentmode: "StripeAPI",
      bookingid: appointmentData?.appointments?.[0]?._id,
      // seviceFee : userinfo?.,
      // paymentmode,
    };

    const { data } = await createCheckoutBillSessionService(postData);
    //  window.open(data.url, '_blank');
    // return
    window.location.href = data.url;

    if (loginUserType === "prospect" || loginUserType === "Prospect") {
      localStorage.removeItem("bookingData");
      localStorage.removeItem("billDetails");
      localStorage.removeItem("appointmentData");
      localStorage.clear();
    } else {
      localStorage.removeItem("bookingData");
      localStorage.removeItem("billDetails");
      localStorage.removeItem("appointmentData");
      // navigate(`/${compName}/`);
    }

    return;
    localStorage.removeItem("bookingData");
    localStorage.removeItem("billDetails");
    localStorage.removeItem("appointmentData");
    navigate(`/${compName}/`);
  }

  return (
    <div className="container my-4 booking-container">
      <div className="row g-4">
        {/* Left Panel */}
        <div className="col-lg-8">
          <div className="card booking-card p-4">
            <div className="d-flex align-items-center mb-3 booking-header">
              {/* <span className=" fw-bold me-2 fs-5">↦</span> */}
              <h5 className="mb-0 booking-title">Review Booking Details</h5>
            </div>

            <div className="d-flex justify-content-center">
              <div className="col-6">
                <label className="form-label">Check-in :</label>
                <h6
                  className="card-title mb-1"
                  style={{
                    color: "#212529",
                    fontWeight: 600,
                  }}
                >
                  {allPayloadData?.checkin
                    ? formatDate(allPayloadData?.checkin)
                    : "No Check-in Date"}
                </h6>
              </div>
              <div className="col-6 border-left">
                <label className="form-label">Check-out :</label>
                <h6
                  className="card-title mb-1"
                  style={{
                    color: "#212529",
                    fontWeight: 600,
                  }}
                >
                  {allPayloadData?.checkout
                    ? formatDate(allPayloadData?.checkout)
                    : "No Check-out Date"}
                </h6>
              </div>
            </div>
            <div className="mt-4">
              <h6>Rooms & Rates</h6>
              {allPayloadData?.bookingdetail?.occupants?.map((item, index) => (
                <div className="border-bottom p-3 mb-2" key={index}>
                  <h6 className="font-16 font-weight-normal">
                    Room {index + 1} :
                  </h6>
                  <p className="m-0">
                    {item?.roomName} - {item?.rateTypeName} included
                  </p>
                  <p>
                    <span
                      className="text-end font-14"
                      style={{
                        color: "#212529",
                        fontWeight: 600,
                      }}
                    >
                      Pax Details :&nbsp;
                    </span>
                    {item?.adults} Adults, {item?.childrens} Children
                  </p>
                  {/* <table className="table table-bordered">
                    <tbody> */}
                  {/* <tr> */}
                  {/* <td style={{ width: "50%", color: "#707b8e" }}>
                          <p className="m-0 font-14">
                            Room Rates Exclusive of Tax
                          </p>
                        </td> */}
                  {/* <td
                          className="text-end font-14"
                          style={{
                            color: "#707b8e",
                            fontWeight: 600,
                          }}
                        >
                          {getCurrency()}&nbsp;{item?.actualcost === 0 ? 0 : item?.actualcost?.toFixed(2)}
                        </td> */}
                  {/* </tr> */}
                  {/* <tr>
                        <td>
                          <strong>Taxes & Fees</strong>
                        </td>
                        <td className="text-end">
                          {getCurrency()} {Number(item?.taxamount.toFixed(2))}
                        </td>
                      </tr> */}
                  {/* </tbody>
                  </table> */}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="col-lg-4">
          <div className="card booking-card p-4">
            <h6 className="mb-3 booking-section-title">Payment Summary</h6>
            {/* <div className="d-flex justify-content-between">
              <span style={{ fontWeight: 500 }}>Total Room Charges </span>
              <span style={{ fontWeight: 600 }}>
                {getCurrency()} {billDetails?.subtotal === 0 ? 0 : billDetails?.subtotal?.toFixed(2)}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <span style={{ fontWeight: 500 }}>Total Taxes</span>
              <span style={{ fontWeight: 600 }}>
                {getCurrency()} {Number(billDetails?.taxamount?.toFixed(2))}
              </span>
            </div> */}
             {(insideDaysLimit?.isWithinRange === true) ? (
              <div className="d-flex justify-content-between">
                <span style={{ fontWeight: 500 }}>
                  Total Price (Inc. Of Taxes) :
                </span>
                <span style={{ fontWeight: 600 }}>
                  {getCurrency()} {lastPrice?.total || lastPrices?.total || 0}
                </span>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-between">
                  <span style={{ fontWeight: 500 }}>Total Price :</span>
                  <span style={{ fontWeight: 600 }}>
                    {getCurrency()} {lastPrice?.total || lastPrices?.total || 0}
                  </span>
                </div>

                <div className="d-flex justify-content-between">
                  <span style={{ fontWeight: 500 ,width: "60%"}}>
                    Amount due at the time of checkin :
                  </span>
                  <span style={{ fontWeight: 600 }}>
                    {getCurrency()}{" "}
                    {lastPrice?.remainingAmount ||
                      lastPrices?.remainingAmount ||
                      0}
                  </span>
                </div>
              </>
            )}

            <div className="d-flex justify-content-between">
              <span style={{ fontWeight: 500 }}>Total Payable now :</span>
              <span style={{ fontWeight: 700 }}>
                {getCurrency()}
                {(insideDaysLimit?.isWithinRange === true)
                  ? lastPrice?.total || lastPrices?.total || 0
                  : lastPrice?.advanceAmount || lastPrices?.advanceAmount || 0}
              </span>
            </div>
            <button
              className="mt-2 btn font-16 w-100 booking-pay-btn"
              onClick={handleGotoPayment}
            >
              Pay Now
            </button>
          </div>

          {/* <div className="alert alert-warning mt-3 booking-insurance-alert">
            Your booking details have been sent to{" "}
            <strong>{rawData?.user?.property?.primaryemail || rawData?.property?.primaryemail || primaryemail  }</strong>.
          </div> */}
        </div>
      </div>
    </div>
  );
}
